import { render, staticRenderFns } from "./AboutMyDatas.vue?vue&type=template&id=f504d9c6&scoped=true&"
import script from "./AboutMyDatas.vue?vue&type=script&lang=js&"
export * from "./AboutMyDatas.vue?vue&type=script&lang=js&"
import style0 from "./AboutMyDatas.vue?vue&type=style&index=0&id=f504d9c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f504d9c6",
  null
  
)

export default component.exports